import { useEffect, useRef } from 'react'

const MAX_CONSOLE_LOGS = 50

// Captures console.error/warn output for the whole session automatically (no
// user action) so the most recent logs can be attached to feedback submissions.
const useConsoleCapture = () => {
  const consoleLogsRef = useRef<string[]>([])

  useEffect(() => {
    consoleLogsRef.current = []
    const originals = {
      error: window.console.error,
      warn: window.console.warn,
    }

    window.console.error = (...args: unknown[]) => {
      consoleLogsRef.current.push(`[ERROR] ${args.map(String).join(' ')}`)
      if (consoleLogsRef.current.length > MAX_CONSOLE_LOGS) consoleLogsRef.current.shift()
      originals.error.apply(window.console, args)
    }
    window.console.warn = (...args: unknown[]) => {
      consoleLogsRef.current.push(`[WARN] ${args.map(String).join(' ')}`)
      if (consoleLogsRef.current.length > MAX_CONSOLE_LOGS) consoleLogsRef.current.shift()
      originals.warn.apply(window.console, args)
    }

    return () => {
      window.console.error = originals.error
      window.console.warn = originals.warn
    }
  }, [])

  return consoleLogsRef
}

export default useConsoleCapture
